<div class="form-container">
    <form>
        <div class="sl-item">
            <label class="item-header" style="font-family: Roboto Slab" for="username">Name</label>
            <input class="sl-input" style="font-family: Noto Sans" type="text" id="username" name="username" placeholder="Your Name" [(ngModel)]="name" required="required"><br>
        </div>
        <div>
            <p class="item-header" style="font-family: Roboto Slab">Interests</p>
            <ul>
                <li *ngFor="let key of interestKeys">
                    <label class="checkbox" [htmlFor]="key">
                        <input type="checkbox" [id]="key" [name]="key" [value]="key" (change)="onCheckChange($event, key)" required="required">
                        <div>
                            <span class="checkbox-text">{{interestOptions[key]}}</span>
                            <img class="toggle-icon" src="assets/plus.svg" alt="">
                        </div>
                    </label>
                </li>
            </ul>
        </div>
        <div class="sl-item" >
            <label class="item-header" style="font-family: Roboto Slab"for="housing">Housing</label>
            <select class="sl-input" style="font-family: Noto Sans" name="housing" id="housing" [(ngModel)]="housing" required="required">
                <option *ngFor="let key of housingKeys" [value]="key">{{housingOptions[key]}}</option>
            </select>
        </div>
        <button mat-raised-button style="font-family: Noto Sans" type="button" (click)="goToOrg()">Switch to Organization</button>
        <button mat-raised-button style="font-family: Noto Sans" type="submit" value="submit" (click)="submit()">Next &rarr;</button>
    </form>
</div>